const regionsMetadataSelector = 'meta[name^="region-"]';

let regionElements: NodeListOf<HTMLMetaElement>;
export const getRegionElements = (): NodeListOf<HTMLMetaElement> => {
  return regionElements || (regionElements = document.querySelectorAll<HTMLMetaElement>(regionsMetadataSelector));
};
